import { Button, Icon, Typography } from '@design-system';
import React from 'react';
import { IoMdClose } from 'react-icons/io';
import { MdKeyboardArrowRight } from 'react-icons/md';
import Select, { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import './Dropdown.scss';
import { useDropdown } from './useDropdown';

export type DropdownProps = {
    options: { id: string; label: string }[];
    placeholder: string;
    onOptionChange: (option: { id: string; label: string }) => void;
    value?: { id: string; label: string } | null | undefined;
    menuIsOpen?: boolean;
    disabled?: boolean;
    isSearchable?: boolean;
    isMulti?: boolean;
    canCreate?: boolean;
    className?: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DropdownIndicator = (props: any) => {
    return (
        <components.DropdownIndicator {...props}>
            <MdKeyboardArrowRight className="dropdown-arrow" fontSize={28} />
        </components.DropdownIndicator>
    );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const MultiValueContainer = (props: any) => {
    return (
        <components.MultiValueContainer {...props}>
            <Typography intrinsic="p" className="dropdown__multi-value__label testouille">
                {props.data.label}
            </Typography>
            <Button variant="tertiary" color="marine" onClick={() => props.removeProps()}>
                <Icon className="remove-button" icon={<IoMdClose />} size={20} color="marine" />
            </Button>
        </components.MultiValueContainer>
    );
};

export const Dropdown: React.FC<DropdownProps> = ({
    options,
    placeholder,
    onOptionChange,
    className,
    value,
    menuIsOpen,
    canCreate = false,
    disabled = false,
    isSearchable = false,
    isMulti = false
}) => {
    const { containerRef, handleScrollToViewPort } = useDropdown(isSearchable);

    if (canCreate) {
        return (
            <div ref={containerRef} className={`dropdown-container ${className}`}>
                <CreatableSelect
                    options={options}
                    ref={undefined}
                    className={`dropdown ${isMulti ? 'dropdown--multi' : ''}`}
                    classNamePrefix="dropdown"
                    components={{ DropdownIndicator, MultiValueContainer }}
                    placeholder={placeholder}
                    onChange={(option) => onOptionChange(option as { id: string; label: string })}
                    onCreateOption={(inputValue) => onOptionChange({ id: '', label: inputValue })}
                    formatCreateLabel={(inputValue) => `Ajouter "${inputValue}"`}
                    menuIsOpen={menuIsOpen}
                    value={value}
                    getOptionValue={(option) => option.id}
                    getOptionLabel={(option) => option.label}
                    isSearchable={isSearchable}
                    isDisabled={disabled}
                    isMulti={isMulti}
                    noOptionsMessage={() => 'Aucun résultat trouvé'}
                    onMenuOpen={handleScrollToViewPort}
                />
            </div>
        );
    } else {
        return (
            <div ref={containerRef} className={`dropdown-container ${className}`}>
                <Select
                    options={options}
                    ref={undefined}
                    className={`dropdown ${isMulti ? 'dropdown--multi' : ''}`}
                    classNamePrefix="dropdown"
                    components={{ DropdownIndicator, MultiValueContainer }}
                    placeholder={placeholder}
                    onChange={(option) => onOptionChange(option as { id: string; label: string })}
                    menuIsOpen={menuIsOpen}
                    value={value}
                    getOptionValue={(option) => option.id}
                    getOptionLabel={(option) => option.label}
                    isSearchable={isSearchable}
                    isDisabled={disabled}
                    isMulti={isMulti}
                    noOptionsMessage={() => 'Aucun résultat trouvé'}
                    onMenuOpen={handleScrollToViewPort}
                />
            </div>
        );
    }
};
